import React from "react";
import ReactDOM from "react-dom";
import "./styles/tailwind.css";
import App from "./App";

ReactDOM.render(
  <App className="min-h-screen" />,
  document.getElementById("root")
);
